// The real name lives in first_name (first) + last_name (last); full_name is
// often just the email prefix, so it's only a fallback.
export function getUserFullName(user) {
  if (!user) return '';
  return [user.first_name, user.last_name].filter(Boolean).join(' ').trim() || user.full_name || '';
}

export function getUserFirstName(user) {
  if (!user) return '';
  return user.first_name || (user.full_name || '').split(' ')[0] || '';
}